import axios from "axios";
import { getAttribution } from "@/lib/attribution";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const subscribeEmail = (email, source = "hero") => {
  const attribution = getAttribution() || {};
  return api
    .post("/subscribe", {
      email,
      source, // which form (hero / guide_section)
      ...attribution, // utm_source/medium/campaign/content/term, referrer, landing_path
    })
    .then((r) => r.data);
};

export const sendContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);
